import ProfileDetails from "pages/profile/details/profile-details";
import MainCard from "components/MainCard";
import {Formik, FormikValues} from "formik";
import * as Yup from "yup";
import {dispatch, useSelector} from "store";
import {openSnackbar} from "store/reducers/snackbar";
import {Button, InputAdornment, InputLabel, OutlinedInput, Stack, Grid, FormHelperText, Checkbox} from "@mui/material";
import {Eye, EyeSlash, } from "iconsax-react";

import {SyntheticEvent, useEffect, useState} from "react";
import IconButton from "components/@extended/IconButton";
import {  getEmployee, updateEmployeePassword } from "store/reducers/employee";
import { useParams } from "react-router-dom";
import { FormControlLabel } from "@mui/material";
import {  getList ,setApiEndPoint} from "store/reducers/role";
import { addItem} from 'store/reducers/employee-role';
import _ from 'lodash';

const getInitialValues = (permissions: FormikValues | null,defaultPermissions:any) => {


    var newPermissions:any = {};

  defaultPermissions?.forEach((element:any) => {
    newPermissions=_.merge(newPermissions,{[element.code]:false});
   
    
    
  });
  
    if (permissions) {
  
        permissions.forEach((element:any) => {
            
            newPermissions[element.code]=true;
        });
    }
    // return _.merge({}, newPermissions);
  
  
    return newPermissions;
  };
  const getDirtyValues = (values:any, initialObject: any): object => {
    const data = { ...values };
    const keyValues = Object.keys(data);
  
    const dirtyValues = keyValues.filter(
        (keyValue) => data[keyValue] !== initialObject[keyValue],
    );
  
    keyValues.forEach((key) => {
        if (!dirtyValues.includes(key)) delete data[key];
    });
  
    return data;
  };
const EmployeeDetails = () => {
     useEffect(()=>{
       

            dispatch(setApiEndPoint('role'))
    },[])
    const { employee_id } = useParams();
    const { list } = useSelector((state) => state.role);
    const {item} = useSelector((state) => state.employee);

    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const handleClickShowNewPassword = () => {
        setShowNewPassword(!showNewPassword);
    };
    const handleClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleMouseDownPassword = (event: SyntheticEvent) => {
        event.preventDefault();
    };
    useEffect(()=>{
        dispatch(getList());
        if(employee_id){

            dispatch(setApiEndPoint('employee/'+employee_id+'/role'))
        }
    },[])
    return (<>
        <Stack spacing={2}>
            <ProfileDetails isEmployee={true}/>
            <MainCard title="Assign Role">
                <Formik
                    initialValues={getInitialValues(item?.roles,list)}
                    onSubmit={async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
                        console.log(values);
                        
                        try {
                            dispatch(addItem(getDirtyValues(values,getInitialValues(item?.roles,list))));
                            dispatch(
                                openSnackbar({
                                    open: true,
                                    message: 'Roles Changed changed successfully.',
                                    variant: 'alert',
                                    alert: {
                                        color: 'success'
                                    },
                                    close: true
                                })
                            );

                            dispatch(getEmployee(parseInt(employee_id?? '')));
                            // setTimeout(() => {
                                // resetForm();
                            // }, 1000);
                            setStatus({ success: false });
                            setSubmitting(false);
                            //  dispatch(getList());
                        } catch (err: any) {
                            setStatus({ success: false });
                            setSubmitting(false);
                        }
                    }}
                >
                    {({ errors, handleBlur, handleChange, setFieldValue,handleSubmit, isSubmitting, touched, values }) => (
                    
                        
                        <form noValidate onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item container spacing={3} xs={12} sm={6}>
                                    {list?.map((role,index)=>{
                                            return <Grid item xs={12}>
                                            <FormControlLabel value="end" control={<Checkbox name={role.code} checked={values[role.code]} value={role.code} onChange={(change)=>{
                                      
                                      setFieldValue(role.code,change.target.checked)
                                  }} />} label={role.name} labelPlacement="end" sx={{ ml: 1 }} />
             
                                                </Grid>
                                    })}
                                
                                  
                                </Grid><Grid item xs={12}>
                                    <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
                                        {/* <Button variant="outlined" color="secondary">
                                            Cancel
                                        </Button> */}
                                        <Button  type="submit" variant="contained">
                                            Assign Roles
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </MainCard>

            <MainCard title="Change Password">
                <Formik
                    initialValues={{
                        password: '',
                        password_confirmation: ''
                    }}
                    validationSchema={Yup.object().shape({
                     
                        password: Yup.string()
                            .required('New Password is required')
                            .matches(
                                /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
                                'Password must contain at least 8 characters, one uppercase, one number and one special case character'
                            ),
                        password_confirmation: Yup.string()
                            .required('Confirm Password is required')
                            .oneOf([Yup.ref('password'), ], "Passwords don't match.")
                    })}
                    onSubmit={async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
                        try {
                            dispatch(updateEmployeePassword(parseInt(employee_id?? '0'),values.password))
                            dispatch(
                                openSnackbar({
                                    open: true,
                                    message: 'Password changed successfully.',
                                    variant: 'alert',
                                    alert: {
                                        color: 'success'
                                    },
                                    close: true
                                })
                            );

                            resetForm();
                            setStatus({ success: false });
                            setSubmitting(false);
                        } catch (err: any) {
                            setStatus({ success: false });
                            setSubmitting(false);
                        }
                    }}
                >
                    {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                        <form noValidate onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item container spacing={3} xs={12} sm={6}>
                                <Grid item xs={12}>
                                        <Stack spacing={1.25}>
                                            <InputLabel htmlFor="password-password">New Password</InputLabel>
                                            <OutlinedInput
                                                id="password-password"
                                                placeholder="Enter New Password"
                                                type={showNewPassword ? 'text' : 'password'}
                                                value={values.password}
                                                name="password"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowNewPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                            edge="end"
                                                            size="large"
                                                            color="secondary"
                                                        >
                                                            {showNewPassword ? <Eye /> : <EyeSlash />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                                inputProps={{}}
                                            />
                                            {touched.password && errors.password && (
                                                <FormHelperText error id="password-password-helper">
                                                    {errors.password}
                                                </FormHelperText>
                                            )}
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Stack spacing={1.25}>
                                            <InputLabel htmlFor="password-password_confirmation">Confirm Password</InputLabel>
                                            <OutlinedInput
                                                id="password-password_confirmation"
                                                placeholder="Enter Confirm Password"
                                                type={showConfirmPassword ? 'text' : 'password'}
                                                value={values.password_confirmation}
                                                name="password_confirmation"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowConfirmPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                            edge="end"
                                                            size="large"
                                                            color="secondary"
                                                        >
                                                            {showConfirmPassword ? <Eye /> : <EyeSlash />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                                inputProps={{}}
                                            />
                                            {touched.password_confirmation && errors.password_confirmation && (
                                                <FormHelperText error id="password-confirm-helper">
                                                    {errors.password_confirmation}
                                                </FormHelperText>
                                            )}
                                        </Stack>
                                    </Grid>
                                </Grid><Grid item xs={12}>
                                    <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
                                        {/* <Button variant="outlined" color="secondary">
                                            Cancel
                                        </Button> */}
                                        <Button  type="submit" variant="contained">
                                            Update Password
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </MainCard>
        </Stack>
    </>);
}
export default EmployeeDetails